import { render, staticRenderFns } from "./configform.vue?vue&type=template&id=0f56f7c6&scoped=true"
import script from "./configform.vue?vue&type=script&lang=js"
export * from "./configform.vue?vue&type=script&lang=js"
import style0 from "./configform.vue?vue&type=style&index=0&id=0f56f7c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56f7c6",
  null
  
)

export default component.exports